import axios from "axios";

const configHeaders = {
  headers: {
    Authorization: "Bearer " + "yourJWTToken",
  },
};

const connectApi = async ({ method = "GET", url, payload }) => {
  return await axios({
    method,
    url,
    data: payload,
    headers: configHeaders,
    responseType: "json",
  });
};

///////
const baseURL = {
  formStatus: "/api/CampaignForm/GetEurekaFormStatus_New",
  submitForm: "/campaign_form_api/api/SESCampaignJourney2024/PostForm",
  otpValidation: "/campaign_form_api/api/OTPValidation/TriggerOTP",
  otpVerify: "/campaign_form_api/api/OTPValidation/VerifyOTP",
  checkPhoneExist:
    "/campaign_form_api/api/SESCampaignJourney2024/CheckPhoneExist",
  checkImei: "/campaign_form_api/api/SESCampaignJourney2024/CheckImei",
  fetchImageId: "/campaign_form_api/api/SESCampaignJourney2024/GetImgId",
};

export const fetchImageId = async () => {
  const config = {
    method: "GET",
    url:baseURL.fetchImageId
  };
  return await connectApi(config);
};

export const checkImei = async ({ imei = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkImei + `?imei=${imei}`,
  };
  return await connectApi(config);
};

export const checkPhoneExist = async ({ phone = "" }) => {
  const config = {
    method: "GET",
    url: baseURL.checkPhoneExist + `?phone=${phone}`,
  };
  return await connectApi(config);
};

export const otpValidation = async (payload) => {
  const config = {
    method: "POST",
    url: baseURL.otpValidation,
    payload,
  };
  return await connectApi(config);
};

export const otpVerify = async (payload) => {
  const config = {
    method: "POST",
    url: baseURL.otpVerify,
    payload,
  };
  return await connectApi(config);
};

export async function formStatus({ lang = "", email = "", phone = "" }) {
  const config = {
    method: "GET",
    url: baseURL.formStatus + `?lang=${lang}&email=${email}&phone=${phone}`,
  };
  return await connectApi(config);
}

export async function submitForm(payload) {
  const config = {
    method: "POST",
    url: baseURL.submitForm,
    payload,
  };
  return await connectApi(config);
}
